export default `
varying vec3 worldNormal;

#ifndef IS_BACKFACE
	uniform sampler2D envMap;
	uniform sampler2D backfaceMap;
	uniform vec2 resolution;
	uniform float ior;
	varying vec3 viewDirection;
	float a = 0.33;
	vec3 fogColor = vec3(1.0);
	#ifdef USE_FRESNEL
		uniform vec3 reflectionColor;
		float fresnelFunc(vec3 viewDirection, vec3 worldNormal) {
			return pow( 0.85 + dot( viewDirection, worldNormal), 10.0 );
		}
	#endif
#endif

varying float vProgress;

void main() {
	#ifdef IS_BACKFACE
		// Backface material
		gl_FragColor = vec4(worldNormal, 1.);
	#else
		// Refraction material
		float alpha = abs(vProgress - .5) * -1. + .5;
		alpha *= 20.;
		alpha = clamp(alpha, 0., 1.);
		vec2 uv = gl_FragCoord.xy / resolution;
		vec3 normal = worldNormal * (1.0 - a);
		#ifdef USE_BACKFACE_MAP
			vec3 backfaceNormal = texture2D(backfaceMap, uv).rgb;
			normal -= backfaceNormal * a;
		#endif
		vec3 refracted = refract(viewDirection, normal, 1.0/ior);
		uv += refracted.xy;
		vec4 tex = texture2D(envMap, uv);
		#ifdef USE_FRESNEL
			float fresnel = fresnelFunc(viewDirection, normal);
			vec3 color = mix(tex.rgb, reflectionColor, fresnel);
			gl_FragColor = vec4(color, alpha);
		#else
			gl_FragColor = vec4(tex.rgb, alpha);
		#endif
	#endif
}
`
